import {Form} from 'react-bootstrap'
import ReactDatePicker from 'react-datepicker'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {appSelector, setJbpDetail} from '../../../../../redux/slices/appSlices'
import moment from 'moment'

export const SelectValidFromDate = () => {
  const {t} = useTranslation()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const dispatch = useAppDispatch()

  const handleChange = (value: Date | null | undefined) => {
    const valid_from = moment(value).format('YYYY-MM-DD')
    dispatch(setJbpDetail({...jbp, valid_from}))
  }

  return (
    <Form.Group controlId='select-valid-from-date'>
      <Form.Label>{t('Valid From')}</Form.Label>
      <ReactDatePicker
        className='form-control'
        selected={jbp?.valid_from ? new Date(jbp.valid_from) : null}
        dateFormat='dd/MM/yyyy'
        onChange={(value: any) => handleChange(value)}
      />
    </Form.Group>
  )
}
